import React from "react";

function TabellaBalloOrari() {
    return(
        <div className="table-container">
            <table className="table m-auto" style={{width: "90%"}}>
                <colgroup>
                    <col style={{ width: "16.666%", minWidth: "100px"}} />
                    <col style={{ width: "16.666%", minWidth: "100px" }} />
                    <col style={{ width: "16.666%", minWidth: "100px" }} />
                    <col style={{ width: "16.666%", minWidth: "100px" }} />
                    <col style={{ width: "16.666%", minWidth: "100px" }} />
                </colgroup>
                <thead>
                <tr>
                    <th className="text-center" scope="col">Lun</th>
                    <th className="text-center" scope="col">Mar</th>
                    <th className="text-center" scope="col">Mer</th>
                    <th className="text-center" scope="col">Gio</th>
                    <th className="text-center" scope="col">Ven</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="text-center">
                        20:45 - 21:45<br/><strong>Salsa</strong><br/><span>base/intermedio on1</span>
                    </td>
                    <td className="text-center">
                        20:30 - 21:40<br/><strong>Salsa</strong><br/><span>intermedio on2</span>
                    </td>
                    <td className="text-center">
                        21:00 - 22:00<br/><strong>Salsa y bachata</strong><br/><span>base on1</span>
                    </td>
                    <td className="text-center">
                        20:45 - 21:45<br/><strong>Salsa</strong><br/><span>beginner on2</span>
                    </td>
                    <td className="text-center">
                        20:45 - 21:45<br/><strong>Lady Style salsa</strong><br/><span>base/intermedio on1</span>
                    </td>

                </tr>
                <tr>
                    <td className="text-center">
                        21:45 - 22:45<br/><strong>Salsa</strong><br/><span>intermedio/avanzato on1</span>
                    </td>
                    <td className="text-center">
                        21:45 - 23:00<br/><strong>Salsa</strong><br/><span>avanzato on2</span>
                    </td>
                    <td className="text-center">
                        22:00 - 23:00<br/><strong>Salsa cubana y rueda</strong>
                    </td>
                    <td className="text-center">
                        21:45 - 22:50<br/><strong>Bachata domenicana</strong>
                    </td>
                    <td className="text-center">
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default TabellaBalloOrari;
